// What a password must have when it is chosen (signing up and setting a new one): the same rules in both
// screens, and the same the API enforces (`minPasswordLength` and `maxPasswordLength` in
// apps/api/src/auth.ts; the API's integration test checks both limits). Signing in checks nothing of this:
// an existing password is only compared with the one stored, so one chosen under older rules still works.
export const PASSWORD_MIN = 10;
export const PASSWORD_MAX = 128;

/** The limits as the texts that name them take them. */
export const PASSWORD_LIMITS = { min: PASSWORD_MIN, max: PASSWORD_MAX };

export type PasswordRule = 'min' | 'max';

/** The rules a value does not meet, in the order they are shown. An empty value is the form's business. */
export function unmetRules(value: string): PasswordRule[] {
  const unmet: PasswordRule[] = [];
  if (value.length < PASSWORD_MIN) unmet.push('min');
  if (value.length > PASSWORD_MAX) unmet.push('max');
  return unmet;
}
